module.exports = __webpack_public_path__ + "img/entertaining_park.64e33a60.png";